import {makeGet} from '@logistics-frontend/utils'
import {Fragment} from 'react'

import {SharedRouteInfoResponse as RouteInfo} from 'src/api/types'

import {classes} from './Status.classes'

export function renderVehiclePlate(str: string = ''): React.ReactElement[] {
  return str
    .split(/(\d+)/)
    .filter(Boolean)
    .map(strOrNumber =>
      !Number.isNaN(+strOrNumber) ? (
        <span key={strOrNumber} className={classes.plateNumbers}>
          {strOrNumber}
        </span>
      ) : (
        <Fragment key={strOrNumber}>{strOrNumber}</Fragment>
      ),
    )
}

export const infoGet = makeGet<RouteInfo>()
